// ** Icons Import
import { CreditCard, Edit, Edit2, User } from "react-feather";
import Member from "../Icon/Member";
import Payment from "../Icon/Payment";
import DeliveryNotes from "../Icon/DeliveryNotes";
import Order from "../Icon/Order";
import SalesOrder from "../Icon/SalesOrder";
import Tax from "../Icon/Tax";
import Stock from "../Icon/Stock";
import Supplier from "../Icon/Supplier";

export default [
    {
        id: "Entry",
        title: "Entry",
        icon: <Edit size={24} />,

        children: [
        
        ],
    },
];
